import { useState } from 'react';

import { AnyValuesDistinctItem } from '@api/catalog';

import Checkbox from '@controls/Checkbox';
import CheckboxGroup from '@controls/CheckboxGroup';

import { scale } from '@scripts/gds';

import { FilterItem } from './types';

interface CheckboxSearchProps {
    items?: FilterItem[];
    withSearch: boolean;
    anyCollection?: {
        isAnyCollection?: boolean;
        items?: AnyValuesDistinctItem[];
        isCategory?: boolean;
    };
    values?: {
        [key: string]: unknown[];
    };
    isChild?: boolean;
}
interface CheckboxState {
    [id: string]: boolean;
}

const CheckboxGroupCategory = ({
    anyCollection = {
        isAnyCollection: false,
        items: [],
        isCategory: false,
    },
    values,
    isChild = false,
    ...props
}: CheckboxSearchProps) => {
    const [checkboxStates, setCheckboxStates] = useState<CheckboxState>(
        (anyCollection.items &&
            anyCollection.isCategory &&
            anyCollection.items.reduce(
                (acc, checkbox) => ({
                    ...acc,
                    [checkbox.id]:
                        (values && values.categories && Boolean(values.categories.find(val => val === checkbox.id))) ||
                        false,
                }),
                {}
            )) ||
            []
    );

    const handleCheckboxChange = (id: string) => {
        setCheckboxStates(prevStates => ({
            ...prevStates,
            [id]: !prevStates[id],
        }));
    };

    return (
        <>
            {anyCollection.isAnyCollection &&
                anyCollection.items?.map(item => {
                    return (
                        <div
                            css={
                                isChild && {
                                    marginLeft: scale(4, true),
                                }
                            }
                        >
                            <CheckboxGroup {...props} id={item.id}>
                                <Checkbox
                                    value={item.id}
                                    key={item.id}
                                    css={{
                                        marginTop: scale(1),
                                        display: 'block',
                                    }}
                                    checked={checkboxStates[item.id]}
                                    onClick={() => handleCheckboxChange(item.id)}
                                >
                                    {item.name}
                                </Checkbox>
                                {anyCollection.isCategory /*&& checkboxStates[item.id]*/ &&
                                    item.children &&
                                    item.children.length > 0 && (
                                        <CheckboxGroup>
                                            <CheckboxGroupCategory
                                                withSearch
                                                anyCollection={{
                                                    isAnyCollection: anyCollection.isAnyCollection,
                                                    isCategory: anyCollection.isCategory,
                                                    items: item.children,
                                                }}
                                                isChild
                                            ></CheckboxGroupCategory>
                                        </CheckboxGroup>
                                    )}
                            </CheckboxGroup>
                        </div>
                    );
                })}
        </>
    );
};

export default CheckboxGroupCategory;
